export default "__VITE_ASSET__nXpA1t7G__"